import React, { useState } from 'react';
import ReactCollapsible from 'react-collapsible';

interface TriggerDetails {
	isExpanded: boolean;
}

interface Props {
	trigger: (
		details: TriggerDetails,
	) =>
		| string
		| React.ReactElement<any, string | React.JSXElementConstructor<any>>;
	children: React.ReactNode;
	open?: boolean;
}

const Collapsible: React.FC<Props> = ({
	trigger,
	children,
	open = false,
	...props
}) => {
	const [isExpanded, setIsExpanded] = useState(open);

	return (
		<ReactCollapsible
			open={isExpanded}
			trigger={trigger({ isExpanded })}
			onTriggerOpening={() => {
				setIsExpanded(true);
			}}
			onTriggerClosing={() => {
				setIsExpanded(false);
			}}
			{...props}>
			{children}
		</ReactCollapsible>
	);
};

export default Collapsible;
